import DropdownComponent from 'components/Widgets/Dropdown/DropdownComponent';

const SelectTypeField = ({ item, selectItem, setNewSelectItem, disabled }) => {
  return (
    <DropdownComponent
      items={item?.setting}
      selectedKey={selectItem?.setting?.value}
      onChange={(val) =>
        setNewSelectItem({
          value: item.setting?.find((it) => it.value === val)?.param,
          setting: {
            value: val ?? ' ',
            param: item.setting?.find((it) => it.value === val)?.param,
          },
        })
      }
      keyItem={'value'}
      valueItem={'param'}
      disabled={disabled}
    />
  );
};

export default SelectTypeField;
